/**
 * 文件说明:
 * ----------------------------------------
 * 创建用户: leo
 * 创建日期 2019/2/28
 */
import _ from 'lodash'
import createModel from 'utils/model'
import {
    records,
    updateRecord,
    types,
    exportRecords,
} from 'message-control/services/sensitive-behavior'

function getInitParams() {
    return {
        user_id: undefined,
        department_id: undefined,
        handled_result: undefined, // 处理结果
        is_handled: undefined, // 是否处理
        type: undefined, // 敏感行为类型
        start_time: undefined,
        end_time: undefined,
        key: undefined,
        limit: 10,
        offset: 0,
    }
}

function getInitState() {
    return {
        list: [],
        selectedRowKeys: [],
        params: getInitParams(),
        total: 0,
        current: 1,
        allOperationsMap: [], // 敏感行为类型
    }
}

export default createModel({
    namespace: 'messageControl_sensitiveBehavior',

    state: getInitState(),

    effects: {
        // 获取types
        *types({payload}, {call, put}) {
            const {meta, data} = yield call(types, payload)

            if (meta && meta.code === 200) {
                yield put({
                    type: 'setProperty',
                    payload: {
                        allOperationsMap: data,
                    },
                })
            }
        },

        // 处理敏感行为
        *updateRecord({payload, callback}, {call}) {
            try {
                const {meta, data} = yield call(updateRecord, payload)

                if (meta && meta.code === 200) {
                    callback && callback(data)
                }
            } catch (e) {
                console.error(e)
            }
        },

        // 获取table
        *records({payload, callback}, {select, call, put}) {
            try {
                // eslint-disable-next-line prefer-const
                let {params, current} = yield select(
                    ({messageControl_sensitiveBehavior}) => messageControl_sensitiveBehavior,
                )

                params = {...params, ...payload.params}
                if (payload.page) {
                    params.offset = params.limit * (payload.page - 1)
                }

                const query = {...params}

                const res = yield call(records, query)

                if (res && res.data) {
                    yield put({
                        type: 'setProperty',
                        payload: {
                            list: res.data,
                            params,
                            total: _.get(res, 'pagination.rows_found'),
                            current: payload.page === undefined ? current : payload.page,
                        },
                    })

                    callback && callback(res.data)
                }
            } catch (e) {
                console.log(e)
            }
        },

        // 导出
        // eslint-disable-next-line no-empty-pattern
        *exportRecords({}, {call, select}) {
            try {
                const params = yield select(
                    ({messageControl_sensitiveBehavior}) => messageControl_sensitiveBehavior.params,
                )
                return yield call(exportRecords, params)
            } catch (e) {
                console.error(e)
            }
        },
    },

    reducers: {
        resetParams(state) {
            return {...state, params: getInitParams()}
        },
        clearSelectedRowKeys(state, action) {
            const {selectedRowKeys} = state
            const removeSelectedRowKeys = action.payload

            const newSelectedRowKeys = selectedRowKeys.filter(
                (item) => removeSelectedRowKeys.indexOf(item) === -1,
            )

            return {...state, selectedRowKeys: newSelectedRowKeys}
        },
    },
})
